import { render, staticRenderFns } from "./transition-modal.vue?vue&type=template&id=668edcf0&"
import script from "./transition-modal.vue?vue&type=script&lang=js&"
export * from "./transition-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports